import { render, staticRenderFns } from "./StarsCalc.vue?vue&type=template&id=6d205317&"
import script from "./StarsCalc.vue?vue&type=script&lang=js&"
export * from "./StarsCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports